import { useNavigate } from "react-router-dom";
import 'react-multi-carousel/lib/styles.css';
function It() {
  const navigate = useNavigate();
  return (
    <>

      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb9">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            IT Staffing
          </h4>

        </div>
      </div>


      {/* START PORTFOLIO */}
      <div className="container">
        <section className="portfolio section-padding" id="portfolio">
          <div className="row">
            <div className="section-title  wow zoomIn">
              <div className="indented">
                <section>
                  <h2>Specialized IT Recruitment Services to Power Your Business</h2>
                  <p>
                    <strong>Introduction</strong>:
                  </p>
                  <p>
                    Our IT recruitment services connect you with top talent,
                    handpicked to drive your business forward. In today’s
                    fast-evolving tech landscape, securing the right professionals is
                    crucial. We combine industry insights, specialized skill matching,
                    and a rigorous selection process to find professionals who fit
                    both your technical needs and company culture.
                  </p>
                  <h3>Why Choose Our IT Recruitment Services?</h3>
                  <ul style={{ padding: 0 % 1 % 1 % 1,fontWeight:400 }}>
                    <li>
                      Industry Expertise: With a deep understanding of the IT sector,
                      we specialize in identifying candidates skilled in fields like
                      software development, data analytics, cloud computing,
                      cybersecurity, and more.
                    </li>
                    <li>
                      Tailored Hiring Solutions: We adapt our recruitment process to
                      your unique needs, ensuring an efficient match for every role,
                      from entry-level tech support to senior management and niche
                      specializations.
                    </li>
                    <li>
                      Quality-Focused Selection Process: Our vetting includes
                      technical assessments, skills verification, and comprehensive
                      interviews, ensuring candidates meet both technical and soft
                      skill requirements.
                    </li>
                  </ul>
                  <h3 style={{ marginTop: -10 }}>End-to-End Recruitment Process</h3>
                  <p>
                    Our full-cycle recruitment service covers every aspect of hiring:
                  </p>
                  <img src="assets/img/recruitment-process.png"  className="responsive-img"/>
                  <p>
                    <strong>1. Job Requirement Analysis</strong>
                    <br />
                    We work closely with your team to define the specific skills,
                    experience, and traits you need.
                  </p>
                  <p>
                    <strong>2. Talent Sourcing</strong>
                    <br />
                    Leveraging a vast network, we source potential candidates through
                    job boards, social media, and our extensive professional
                    connections.
                  </p>
                  <p>
                    <strong>3. Candidate Screening &amp; Interviews</strong>
                    <br />
                    Through technical assessments and in-depth interviews, we evaluate
                    each candidate’s expertise, problem-solving ability, and fit with
                    your company culture.
                  </p>
                  <p>
                    <strong>4. Offer &amp; Onboarding Assistance</strong>
                    <br />
                    We manage offer negotiations and help streamline the onboarding
                    process, ensuring a smooth transition for both you and the new
                    hire.
                  </p>
                  <h3>Areas of IT Recruitment Expertise</h3>
                  <p>
                    Our recruitment services cover a wide range of IT roles,
                    including:
                  </p>
                  <ul style={{ padding: 0 % 1 % 1 % 1,fontWeight:400}}>
                    <li style={{ lineHeight: 1.1 }}>Software Development</li>
                    <li style={{ lineHeight: 1.1 }}>Data Science &amp; Analytics</li>
                    <li style={{ lineHeight: 1.1 }}>Cloud Computing &amp; DevOps</li>
                    <li style={{ lineHeight: 1.1 }}>ERP Solutions</li>
                    <li style={{ lineHeight: 1.1 }}>Infrastructure Solutions</li>
                    <li style={{ lineHeight: 1.1 }}>Cyber Security</li>

                    <li style={{ lineHeight: 1.1 }}>All levels of IT support</li>

                    <li style={{ lineHeight: 1.1 }}>Short term and long term project staffing</li>

                  </ul>
                  <h3 style={{ marginTop: -6 }}>Ready to Hire Top IT Talent?</h3>
                  <p>
                    Whether you’re a start-up looking to build a tech team from
                    scratch or an established firm seeking to enhance your IT
                    capabilities, we’re here to support you every step of the way. Let
                    us help you find professionals who will bring innovative solutions
                    and proven expertise to your organization.
                  </p>
                  <p style={{ marginBottom: -10 }}>
                    {/* <a href="index.html#contact">Contact Us</a>  */}
                    <button onClick={() => navigate("/contact")} className="btn-link">
                      Contact Us
                    </button> today to learn how our
                    IT recruitment services can help you attract and retain top
                    talent.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

       {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" />
                2024 Celersoft. All rights reserved.
              </span>
            </div>
            {/* <div className="col-md-6 text-center text-md-end text-body">
              <a
                    className="border-bottom text-primary"
                    href="https://htmlcodex.com"
                >
                    HTML Codex
                </a>{" "}
                Distributed By{" "}
                <a
                    className="border-bottom text-primary"
                    href="https://themewagon.com"
                >
                    ThemeWagon
                </a>


              </div> */}
          </div>
        </div>
      </div>
      {/* <a href="/it" className="btn btn-primary btn-lg-square back-to-top">
          <i className="fa fa-arrow-up" />
        </a> */}

      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa fa-arrow-up" />
      </button>


    </>

  );
};

export default It